import { UTILITY_IDS } from '~/utils/constants';

type MeterRegex = {
  utilityId: number;
  regexExpressions: RegExp[];
  errorMessage: string;
};

export const regexMapMeterNumber: MeterRegex[] = [
  {
    utilityId: UTILITY_IDS['Portland General Electric'],
    regexExpressions: [/^\d{8}[A-Z]{2}$/],
    errorMessage:
      'Please enter a valid PGE meter number (8 digits followed by 2 Uppercase letters)',
  },
  {
    utilityId: UTILITY_IDS['Pacific Power OR'],
    regexExpressions: [/^\d{8}$/],
    errorMessage: 'Please enter a valid Pacific Power OR meter number (8 digits)',
  },
  {
    utilityId: UTILITY_IDS['Dominion Energy VA'],
    regexExpressions: [/^\d{10}$/],
    errorMessage: 'Please enter a valid Dominion Energy VA meter number (10 digits)',
  },
  {
    utilityId: UTILITY_IDS['PEPCO MD'],
    regexExpressions: [/^[A-Z]{3}\d{9}$/, /^[14][A-Z]{2}\d{9}$/],
    errorMessage:
      "Please enter a valid PEPCO MD meter number (3 uppercase letters followed by 9 digits) or a meter number starting with '1' or '4', followed by 2 uppercase letters and 9 digits",
  },
  {
    utilityId: UTILITY_IDS['Ameren IL'],
    regexExpressions: [/^\d{8}$/],
    errorMessage: 'Please enter a valid Ameren IL meter number (8 digits)',
  },
  {
    utilityId: UTILITY_IDS['Commonwealth Edison'],
    regexExpressions: [/^\d{9}$/],
    errorMessage: 'Please enter a valid Commonwealth Edison meter number (9 digits)',
  },
  {
    utilityId: UTILITY_IDS['Baltimore Gas & Electric'],
    regexExpressions: [/^[A-Z]{1}\d{9}$/],
    errorMessage:
      'Please enter a valid BG&E meter number (1 Uppercase letters followed by 9 digits)',
  },
  {
    utilityId: UTILITY_IDS['Delmarva Power MD'],
    regexExpressions: [/^[A-Z]{3}\d{9}$/],
    errorMessage:
      'Please enter a valid Delmarva Power MD meter number (3 Uppercase letters followed by 9 digits)',
  },
  {
    utilityId: UTILITY_IDS['Potomac Edison MD'],
    regexExpressions: [/^[A-Z]\d{8,9}$/],
    errorMessage:
      'Please enter a valid Potomac Edison MD meter number (1 Uppercase letters followed by 8 or 9 digits)',
  },
  {
    utilityId: UTILITY_IDS['Eversource / NSTAR'],
    regexExpressions: [/^\d{7}$/],
    errorMessage: 'Please enter a valid Eversource meter number (7 digits)',
  },
  {
    utilityId: UTILITY_IDS['Xcel Energy MN'],
    regexExpressions: [/^\d{8,9}$/],
    errorMessage: 'Please enter a valid Xcel Energy MN meter number (8 or 9 digits)',
  },
];
